import {
    inject,
    postConstruct,
    singleton
} from '../../infrastructure/di/annotations';
import {
    FeatureAppConfigurationModel,
    SpaGlobalConfig
} from '../../../generated/core';
import fetch from '@strictsoftware/fetch';

// Loads all feature app configs from homepage feature-app servlet
@singleton('CMSFeatureAppService', {env: 'client'})
export class CMSFeatureAppService {
    @inject()
    private spaGlobalConfig!: SpaGlobalConfig;

    private featureApps: Promise<FeatureAppConfigurationModel[]> | undefined =
        undefined;

    @postConstruct()
    initialize() {
        if (this.spaGlobalConfig.faConfigUrl) {
            this.featureApps = fetch(this.spaGlobalConfig.faConfigUrl).then(
                async response => {
                    if (!response.ok) {
                        return [] as FeatureAppConfigurationModel[];
                    }
                    const json = (await response.json()) as any;
                    return (json.featureApps ||
                        []) as FeatureAppConfigurationModel[];
                }
            );
        }
    }

    public async getFeatureAppConfig(
        faName: string
    ): Promise<FeatureAppConfigurationModel | undefined> {
        if (!this.featureApps) {
            return undefined;
        }
        const featureApps = await this.featureApps;
        return featureApps.find(fa => fa.name === faName);
    }
}
